import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const CadIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        fillRule="evenodd"
        d="M6.5.77v22.46h11V.77Zm3.28 3.17a1.84 1.84 0 1 1-1.84 1.84 1.84 1.84 0 0 1 1.84-1.84ZM10.19 21a2.25 2.25 0 1 1 2.25-2.25A2.25 2.25 0 0 1 10.19 21Zm3.14-5.39a3.06 3.06 0 1 1 3.06-3 3.06 3.06 0 0 1-3.06 3Z"
      />
    </IconBase>
  );
};

export default CadIcon;
